module.exports = __webpack_public_path__ + "img/coffee.53e25330.svg";